// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__KihGx","amount":"Amount_amount__M_3LI","tip":"Amount_tip__1UFpb","tipHeader":"Amount_tipHeader__1ojug","tipsWrap":"Amount_tipsWrap__1CdGD"};